<template>
  <div class="col-12" style="display:flex; flex-wrap:wrap;">
    <div class="w-100 d-flex mt-2 items-center">
      <button-with-icon
          v-if="showSubmitButton"
          :icon-name="null"
          :text="$t(isEditing ? 'order.update_instruction' : 'order.create_instruction').toUpperCase()"
          btn-classes="text-primary"
          class="text-sm"
          @onClick="$emit('submit')"
      ></button-with-icon>
    </div>
    <div v-if="model.pdf_link" class="w-100 d-flex mt-2 items-center" style="display:flex; flex-wrap:wrap;">
      <div v-if="isAllSubmitted && !isEditing" class="col-6">
        <button-with-icon
            :icon-name="null"
            :text="$t('order.download_as_pdf').toUpperCase()"
            class="mx-1 text-sm"
            @onClick="openInNewTab(model.pdf_link)"
        ></button-with-icon>
      </div>
    </div>
    <div v-if="isAllSubmitted && !isEditing && model.order_fabric_excel_link"
         class="w-100 d-flex mt-2 items-center" style="display:flex; flex-wrap:wrap;">
      <div v-if="isAllSubmitted && !isEditing" class="col-6 mb-2">
        <button-with-icon
            :icon-name="null"
            :text="$t('order.download_as_excel').toUpperCase()"
            class="mx-1 text-sm"
            @onClick="openInNewTab(model.order_fabric_excel_link)"
        ></button-with-icon>
      </div>

      <div class="col-6 mb-2">
        <button-with-icon
            :icon-name="null"
            :text="$t('order.edit').toUpperCase()"
            class="mx-1 text-sm"
            @onClick="$emit('update:isEditing', true)"
        ></button-with-icon>
      </div>

      <div class="col-6">
        <button-with-icon
            :btn-styles="{border: '1px solid red !important', color: 'red !important'}"
            :icon-name="null"
            :text="$t('order.cancel_instruction').toUpperCase()"
            class="mx-1 text-sm"
            @onClick="onClickCancelInstruction"
        ></button-with-icon>
      </div>

      <div class="col-6">
        <button-with-icon
            :icon-name="null"
            :text="$t('order.send').toUpperCase()"
            class="mx-1 text-sm"
            @onClick="sendMail"
        ></button-with-icon>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonWithIcon from "@/assets/components/widget/ButtonWithIcon";
import CustomMultiSelect from "@/assets/components/inputs/CustomMultiSelect";
import {CREATE_ITEM} from "@/core/services/store/REST.module";

export default {
  name: "BottomButtons",
  components: {CustomMultiSelect, ButtonWithIcon},
  props: {
    isValidToSubmit: {
      required: true,
      type: Boolean,
    },
    isEditing: {
      required: true,
      type: Boolean,
    },
    model: {
      required: true,
    },
    emails: {
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    orderId: {
      required: true,
    },
    sendMailUrl: {
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    onClickCancelInstruction() {
      const self = this;
      this.sweetAlertConfirm(this.$t('order.are_you_sure_about_cancelling_all_the_instruction_from_current_type')).then(response => {
        if (response) {
          self.$emit('onCancelInstruction');
        }
      })
    },
    sendMail() {
      let self = this;
      let payloads = {
        url: self.sendMailUrl,
      }

      this.sweetAlertLoading();
      this.$store.dispatch(CREATE_ITEM, payloads).then(response => {
        if (response.status) {
          self.sweetAlertSuccess(self.$t('general.success'));
        } else {
          let result = response.data.response;
          if (result.hasOwnProperty('data') && result.data.hasOwnProperty('message')) {
            self.sweetAlertError(result.data.message);
          } else {
            self.sweetAlertError(result.data);
          }
        }
        self.sweetAlertClose();
      }).catch(response => {
        self.sweetAlertClose();
        let result = response.data.response;
        if (result.hasOwnProperty('data') && result.data.hasOwnProperty('message')) {
          self.sweetAlertError(result.data.message);
        } else {
          self.sweetAlertError(result.data);
        }
      });
    }
  },
  computed: {
    showSubmitButton() {
      if (this.isEditing) {
        return this.isValidToSubmit;
      } else {
        return !this.model.id && this.isValidToSubmit && this.isAllSubmitted;
      }
    },
    isAllSubmitted() {
      return true;
    },
  },
}
</script>

<style scoped>

</style>
